import { updatePropertyIcons } from '../layers';
import Property from '../models/property';

const onDiscardedListUpdate = ( ctx, event ) => {
    const { discarded, propertyKey, value } = event.detail;

    if ( propertyKey !== 'property' ) {
        return;
    }

    const property: Property = ctx.properties.get( parseInt( value ) );

    if ( !property ) {
        return;
    }

    property.discarded = discarded;

    updatePropertyIcons( ctx );
};

export default onDiscardedListUpdate;
